import { ref } from 'vue';

const _open = ref(false);

export function useGlobalSearch() {
  function openSearch() {
    _open.value = true;
  }
  function closeSearch() {
    _open.value = false;
  }
  return { searchOpen: _open, openSearch, closeSearch };
}
